import styled from "@emotion/styled";
import React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import mainContext from "../../../contexts/mainContext";
import { Chip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { addEditSupportCategories } from "../../../Controllers/AppManagement/helpSupport";
import { __snackBarSeverity } from "../../../constants";
export default function AddEditCategory({
  open,
  data,
  index,
  onAdd,
  onEdit,
  handleClose,
}) {
  const { setSnackBar } = React.useContext(mainContext); /* App State */

  const [state, setState] = React.useState({
    /* Component state */
    subCategoryList: data.subCategory ? data.subCategory : [],
    category: data.category,
    subCategory: "",
  });

  const callSnackBar = (msg, type) => {
    /* Alert for User */
    setSnackBar({
      status: true,
      text: msg,
      severity: __snackBarSeverity[type],
    });
  };

  const handleAddEdit = async () => {
    let request = {
      category: state.category,
      subCategory: state.subCategoryList,
    };
    if (index !== -1) {
      /*  Update category */
      request["categoryId"] = data._id;
    } else {
      if (!request.category) {
        return callSnackBar("Please add category name", "error");
      }
      if (request.subCategory.length === 0) {
        return callSnackBar(
          "Please add alteast one sub-category name",
          "error"
        );
      }
    }
    const res = await addEditSupportCategories(request);
    if (res.data.status === 200) {
      callSnackBar(res.data.message, "success");
      if (index === -1) {
        /*  Update category */
        onAdd(res.data.data.supportCategory);
      } else {
        onEdit(res.data.data.supportCategory, index);
      }
    } else {
      callSnackBar(res.data.errors[0].message);
    }
  };

  const handleAddRemove = (index) => {
    let temp = [...state.subCategoryList];
    if (index === 0 || index) {
      /* Remove category */
      temp.splice(index, 1);
      setState({ ...state, subCategoryList: temp });
    } else {
      if (!temp.some((object) => object.name === state.subCategory)) {
        if (state.subCategory) {
          temp.push({ name: state.subCategory });
          setState({ ...state, subCategoryList: temp, subCategory: "" });
        }
      }
    }
  };
  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {index === -1
            ? "Add Category/sub-category"
            : "Edit Category/sub-category"}
        </DialogTitle>
        <DialogContent sx={{ minWidth: "400px", maxWidth: "400px" }}>
          <TextField
            autoFocus
            margin="dense"
            id="content"
            label="Category"
            type="text"
            inputProps={{ maxLength: 100 }}
            defaultValue={state.category}
            fullWidth
            onChange={(e) => {
              setState({ ...state, category: e.target.value });
            }}
          />
          <div>
            <TextField
              margin="dense"
              id="content"
              label="Sub-category"
              type="text"
              fullWidth
              inputProps={{ maxLength: 100 }}
              value={state.subCategory}
              onChange={(e) => {
                setState({ ...state, subCategory: e.target.value });
              }}
            />
            <Button
              onClick={() => handleAddRemove()}
              sx={{ marginTop: "10px" }}
              color="success"
              variant="contained"
              size="small"
            >
              Add sub-category
            </Button>
          </div>

          <SubCategoryBox>
            {state.subCategoryList.map((object, index) => (
              <Chip
                sx={{ margin: "0 5px 5px 0px" }}
                label={object.name}
                onDelete={() => {
                  handleAddRemove(index);
                }}
                deleteIcon={<DeleteIcon />}
              />
            ))}
          </SubCategoryBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} size="small">
            Cancel
          </Button>
          <Button onClick={handleAddEdit} variant="contained" size="small">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

const SubCategoryBox = styled("div")`
  margin: 10px 0px;
`;
